module.exports = __webpack_public_path__ + "img/ww-select.3950dc80.png";